// userApi.js
import { createApi } from "@reduxjs/toolkit/query/react";
import { customFetchBase } from "../customFetchBase";

export const userApi = createApi({
  reducerPath: "userApi",
  baseQuery: customFetchBase({ url: "user" }),
  endpoints: (builder) => ({
    // Get all users (admin only)
    getUsers: builder.query({
      query: (params = {}) => {
        const {
          page = 1,
          limit = 10,
          search,
          role,
          isActive,
          sort = "-createdAt",
        } = params;

        let url = `?page=${page}&limit=${limit}&sort=${sort}`;
        if (search) url += `&q=${search}`;
        if (role) url += `&role=${role}`;
        if (isActive !== undefined) url += `&isActive=${isActive}`;

        return {
          url,
          method: "GET",
        };
      },
    }),

    // Get single user by ID
    getUserById: builder.query({
      query: (id) => `/${id}`,
    }),

    // Update user
    updateUser: builder.mutation({
      query: ({ id, data }) => ({
        url: `/${id}`,
        method: "PATCH",
        body: data,
      }),
    }),

    // Get current user favorites
    getFavorites: builder.query({
      query: () => "/favorites",
    }),

    // Add favorite gym
    addFavoriteGym: builder.mutation({
      query: (gymId) => ({
        url: `/favorites/gym/${gymId}`,
        method: "POST",
      }),
    }),

    // Remove favorite gym
    removeFavoriteGym: builder.mutation({
      query: (gymId) => ({
        url: `/favorites/gym/${gymId}`,
        method: "DELETE",
      }),
    }),

    // Add favorite coach
    addFavoriteCoach: builder.mutation({
      query: (coachId) => ({
        url: `/favorites/coach/${coachId}`,
        method: "POST",
      }),
    }),

    // Remove favorite coach
    removeFavoriteCoach: builder.mutation({
      query: (coachId) => ({
        url: `/favorites/coach/${coachId}`,
        method: "DELETE",
      }),
    }),
  }),
});

// Export hooks
export const {
  useGetUsersQuery,
  useGetUserByIdQuery,
  useUpdateUserMutation,
  useGetFavoritesQuery,
  useAddFavoriteGymMutation,
  useRemoveFavoriteGymMutation,
  useAddFavoriteCoachMutation,
  useRemoveFavoriteCoachMutation,
} = userApi;
